import { TextField } from '@material-ui/core'
import { Collapse } from '@material-ui/core/'
import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import ArrowSvg from '../../../../assets/images/arrow-back.svg'
import CameraSvg from '../../../../assets/images/camera.svg'
import CameraPurpleSvg from '../../../../assets/images/cameraPurple.svg'
import Layout from '../../../components/Provider/Layout'
import QrScan from '../../../components/Provider/QrScan'
import RadioButtons from '../../../components/Provider/RadioButton'
import CustomButton from '../../../components/shared/CustomButton'
import CustomCamera from '../../../components/shared/CustomCamera'
import CustomSelect from '../../../components/shared/CustomSelect'
import Switch from '../../../components/shared/CustomSwitch'
import Loading from '../../../components/shared/Loading'
import MessageModal from '../../../components/shared/MessageModal'
import UploadButton from '../../../components/shared/UploadButton'
import AdminService from '../../../services/AdminServices'
import ProviderService from '../../../services/ProviderServices'
import './ReubicationDetail.scss'


const ReubicationDetail = ({ match }) => {
  const history = useHistory()
  const { location: { state: { cudToProcess, sessionId } } } = history
  const [pickupPointId, setPickupPointId] = useState(null)
  const [loading, setLoading] = useState(false)
  const [photo, setPhoto] = useState(null)
  const [currentScreen, setScreen] = useState(0)
  const [location, setLocation] = useState('')
  const [options, setOptions] = useState([])
  const [otherUbication, setOtherUbication] = useState(false)
  const [otherUbicationText, setOtherUbicationText] = useState('')
  const [hasObservations, setHasObservations] = useState(false)
  const [observations, setObservations] = useState('')
  const [modalErrorLocation, setModalErrorLocation] = useState(false)
  const [modalInvalidLocation, setModalInvalidLocation] = useState(false)
  const otherRef = useRef(null)
  let { id } = useParams()

  useEffect(() => {
    const { pickupPointId } = JSON.parse(localStorage.getItem('userappret'))
    setPickupPointId(pickupPointId)
    getOptions()
  }, [])

  const getOptions = async () => {
    const { pickupPointId } = JSON.parse(localStorage.getItem('userappret'))
    let newPlaces = []
    try {
      setLoading(true)
      const places = await AdminService.getPlace(pickupPointId)
      places.forEach(p => {
        const newplace = {
          value: p.id,
          label: p.name
        }
        newPlaces.push(newplace)
      })
      setOptions(newPlaces)
      setLocation(cudToProcess.placeId)
      setLoading(false)
    } catch (e) {
      setLoading(false)
    }
  }

  const handleChange = event => {
    setLocation(event.target.value)
    setOtherUbication(false)
    setOtherUbicationText('')
  }

  const handlePicture = (image) => {
    // el image es un base64 png
    console.log(image)
    if (image !== 'data:,') {
      setPhoto(image)
    } else {
      setPhoto(null)
    }
    setScreen(0)
  }

  const handleAddCud = async () => {
    try {
      setLoading(true)
      const cud = {
        id,
        photo,
        location,
        numProducts: cudToProcess.numProducts,
        sessionId: sessionId,
        type: cudToProcess.type
      }
      if (otherUbicationText) {
        const newPlace = await AdminService.createPlace(pickupPointId, otherUbicationText, 'OTROS')
        console.log(newPlace)
        cud.location = newPlace[0].id
      }
      await ProviderService.updateUbication(cud, photo)
      setLoading(false)
      history.push('/reubicacion')
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  const handleOtherClick = () => {
    setOtherUbication(!otherUbication)
    setOtherUbicationText('')
    setLocation('')
  }

  const handleScan = (data) => {
    if (data) {
      try {
        const newPlace = JSON.parse(data).placeId
        setScreen(0)
        const founded = options.find(c => c.value == newPlace)
        if (founded) {
          if (newPlace === location) {
            setModalInvalidLocation(true)
          } else {
            setLocation(newPlace)
            setOtherUbication(false)
            setOtherUbicationText('')
          }
        }
        else setModalErrorLocation(true)
      } catch (e) {
        console.log('ERROR: ', e)
      }
    }
  }

  const getTotalSkus = (skus) => {
    let total = 0
    skus.map(sku => total += sku.quantity)
    return total
  }

  const renderScreen = () => {

    switch (currentScreen) {
      case 1: return <CustomCamera onClose={() => setScreen(0)} handlePicture={handlePicture} />
      case 2: return (
        <QrScan
          handleScan={handleScan}
          onClose={() => setScreen(0)}
          title='Escaneo de locker'
          subtitle='Escanea el código QR ubicado en la puerta del locker.'
        />
      )
      default: return (
        <Layout>
          <Loading
            visible={loading}
          />
          <MessageModal
            visible={modalErrorLocation}
            closeModal={() => setModalErrorLocation(false)}
            type={12}
            title='Ubicación no listada'
            txtBtn1='ESCANEAR OTRO LOCKER'
            onClickBtn1={() => {
              setModalErrorLocation(false)
              setScreen(2)
            }
            }
            txtBtn2='REGRESAR A LA LISTA'
            onClickBtn2={() => {
              setModalErrorLocation(false)
              setScreen(0)
            }
            }
            inlineButtons
          >
            <div className='modal-warning-message'>
              <p>La ubicación escaneada no aparece en la lista</p>
            </div>
          </MessageModal>
          <MessageModal
            visible={modalInvalidLocation}
            closeModal={() => setModalInvalidLocation(false)}
            type={12}
            title='Ubicación ya registrada'
            txtBtn1='ESCANEAR OTRO LOCKER'
            onClickBtn1={() => {
              setModalInvalidLocation(false)
              setScreen(2)
            }
            }
            txtBtn2='REGRESAR A LA LISTA'
            onClickBtn2={() => {
              setModalInvalidLocation(false)
              setScreen(0)
            }
            }
            inlineButtons
          >
            <div className='modal-warning-message'>
              <p>Este cartón ya se encuentra en este locker.</p>
            </div>
          </MessageModal>
          <div className='reception_detail-container'>
            <div className='reception_detail-subcontainer'>
              <div className='reception_detail-mainheader'>
                <div onClick={() => history.push('/reubicacion', { sessionId })}>
                  <img src={ArrowSvg} alt='atras' />
                </div>
                <h3>Cambio de ubicación</h3>
              </div>
              <div className='reception_detail-header'>
                {cudToProcess.skus
                  ? <>
                    <h3>OC: {cudToProcess.guide}</h3>
                    {cudToProcess.skus.map(sku =>
                      <h4>SKU: {sku.sku} <span>x{sku.quantity}</span></h4>)}
                    <h5>{getTotalSkus(cudToProcess.skus)} PRODUCTO{getTotalSkus(cudToProcess.skus) > 1 && 'S'}</h5>
                  </>
                  : <>
                    <h3>Guía: {cudToProcess.guide}</h3>
                    <h4>CUD: {cudToProcess.id}</h4>
                    <h5>{cudToProcess.numProducts} PRODUCTO{cudToProcess.numProducts > 1 && 'S'}</h5>
                  </>}
              </div>
              <div className='reception_detail-body'>
                <div className='reception_detail-select-container'>
                  <div className='select_title'>
                    <h3>Ubicación</h3>
                    <div onClick={() => setScreen(2)}>
                      <p>ESCANEAR QR</p>
                    </div>
                  </div>
                  <div className='select_radiobutton'>
                    <RadioButtons checked={!otherUbication} handleChange={() => setOtherUbication(false)} />
                    <CustomSelect
                      value={location}
                      handleChange={handleChange}
                      options={options}
                      disabled={otherUbication}
                    />
                  </div>
                </div>
                <div className='others-container'>
                  <div className='others-check'>
                    <RadioButtons checked={otherUbication} handleChange={() => {
                      setOtherUbication(true)
                    }
                    } />
                    {otherUbication ? (<div className='others-input'>
                      <TextField
                        value={otherUbicationText}
                        type={'text'}
                        onChange={e => {
                          setOtherUbicationText(e.target.value)
                        }}
                        fullWidth
                      />
                    </div>) : <p>Otros</p>}
                  </div>
                </div>
                <div className='reception_detail-evidence'>
                  <h3>Evidencia</h3>
                  <UploadButton
                    image={photo ? CameraPurpleSvg : CameraSvg}
                    text='TOMAR FOTO'
                    isCompleted={photo}
                    onClick={() => setScreen(1)}
                  />
                </div>
                <div className='reception_detail-observations'>
                  <div className='observations-head'>
                    <h3>Observaciones</h3>
                    <Switch
                      checked={hasObservations}
                      onChange={() => setHasObservations(!hasObservations)}
                      color="#9240C9"
                    />
                  </div>
                  <Collapse in={hasObservations} className='observations-textarea'>
                    <textarea value={observations} onChange={e => setObservations(e.target.value)} />
                  </Collapse>
                </div>
              </div>
            </div>
            <div className='reception_detail-footer'>
              <CustomButton
                margin='20px 0 20px 20px'
                onClick={() => history.push('/reubicacion')}>
                CANCELAR
              </CustomButton >
              <CustomButton
                filled={true}
                margin='20px 20px 20px 0'
                disabled={!photo || !((otherUbication && otherUbicationText) || (!otherUbication && location))}
                onClick={handleAddCud}
              >
                GUARDAR
              </CustomButton >
            </div>
          </div>
        </Layout>
      )
    }
  }

  return renderScreen()
}

export default ReubicationDetail
